enum ApplicantRoutes {
  PROGRAM_INTRO = '/program/:programId/intro',
  SECTIONS_OVERVIEW = '/program/:programId/intro/sections',
  INTRO_PAGE = '/program/:programId/intro/:screenKey',
  APPLICATION_PORTAL = '/application/portal',
  APPLICATION = '/application/:applicationId',
  W9_TAX_FORM = '/application/:applicationId/w9',
  APPLICATION_REVIEW = '/application/:applicationId/review',
  SUBMISSION_CONFIRMATION = '/application/:applicationId/submit/confirmation',
  W9_TAX_FORM_QUESTION = '/application/:applicationId/questions/w9',
  BANK_ACCOUNT = '/application/:applicationId/questions/bankAccount',

  SECTION_OVERVIEW = '/application/:applicationId/sections/:sectionKey',
  QUESTION_GROUP_OVERVIEW = '/application/:applicationId/groups/:groupKey',
  QUESTION = '/application/:applicationId/questions/:questionKey',

  PROFILE = '/application/profile',
  PROCESS_AND_SUBMIT = '/application/process-and-submit',

  CASE_DETAILS = '/case/:caseId/details',
  FULFILLMENT_DETAILS = '/case/:caseId/fulfillment/:fulfillmentId/details',
}
export default ApplicantRoutes;
